export const LupaBuscar = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.3636 1C6.90721 1 5.48354 1.43186 4.2726 2.24098C3.06167 3.05009 2.11786 4.20012 1.56052 5.54563C1.00319 6.89114 0.857367 8.3717 1.14149 9.80008C1.42562 11.2285 2.12693 12.5405 3.15675 13.5703C4.18657 14.6001 5.49863 15.3014 6.92703 15.5856C8.35543 15.8697 9.836 15.7239 11.1815 15.1665C12.527 14.6092 13.6771 13.6654 14.4862 12.4545C15.2953 11.2436 15.7272 9.8199 15.7272 8.36353C15.7271 6.41064 14.9512 4.53777 13.5703 3.15687C12.1894 1.77596 10.3165 1.00012 8.3636 1V1Z"
        stroke="#3C6EBE"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M13.8574 13.8574L19.0001 19"
        stroke="#3C6EBE"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
};
